<div fxLayout="column" fxLayoutGap="10">
  <h2 fxFlex>Clientes que possuem planos a serem atualizados</h2>
  <table-responsive
    fxFlex
    table
    [length]="length"
    (changePage)="changePage($event)"
    (filter)="filter($event)"
    [displayedColumns]="displayedColumns"
    [dataSource]="dataSource"
    [configColumns]="configColumns"
    (onSelectionChange)="onSelectionChange($event)"
  >
  </table-responsive>
  <!-- applicar e cancelar -->
  <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10">
    <button mat-raised-button (click)="cancel()">SAIR</button>
    <button mat-raised-button [disabled]="!length" (click)="applyConfirm()">APLICAR</button>
  </div>
</div>
